"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonText = void 0;

var time_conversion_1 = require("./time-conversion");

var removeRxp = /\${(.*?)}/g;

function getButtonText(source, timeRemaining, digits) {
  if (digits === void 0) {
    digits = 0;
  }

  var parsed = source;
  var countdown;

  if (digits === 0) {
    countdown = Math.ceil(timeRemaining / 1000);
  } else {
    countdown = timeRemaining / 1000;
  }

  var removeMatch = removeRxp.exec(source);
  removeRxp.lastIndex = 0;

  if (removeMatch && removeMatch.length > 0) {
    if (timeRemaining <= 0) {
      parsed = source.replace(removeMatch[0], '');
    } else {
      var timeText = "" + (digits !== 0 ? countdown.toFixed(digits) : countdown);

      if (countdown * 1000 > 60000) {
        timeText = time_conversion_1.timeConversion(countdown * 1000);
      }

      var insertText = removeMatch[1].replace('$countdown', timeText);
      parsed = source.replace(removeMatch[0], insertText);
    }
  } else {
    var timeText = "" + (digits !== 0 ? countdown.toFixed(digits) : countdown);

    if (countdown * 1000 > 60000) {
      timeText = time_conversion_1.timeConversion(countdown * 1000);
    }

    parsed = source.replace('$countdown', timeText || '0');
  }

  return parsed;
}

exports.getButtonText = getButtonText;